import React, { FC, useState } from 'react';
import { Button, BaseModal, ToastMessage } from '@cokitchen/cokitchen-components';
import { UserIcon } from 'cokitchen-icons';
import { toast } from 'react-toastify';
import { ReviewType } from 'models/review.model';
import { ENUM_ITEM_TYPE } from 'utils/enum';
import { apiService } from 'utils/api';

interface Props {
  show: boolean;
  onClose: () => void;
  onSuccess: () => void;
  review: ReviewType;
  itemType: ENUM_ITEM_TYPE;
}

interface FinishOrderFooterProps {
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}
const baseUrl = process.env.REACT_APP_BRAND_MGT_API_URL;

const MarkAsResolvedFooter: FC<FinishOrderFooterProps> = ({ onCancel, onConfirm, loading }) => (
  <div className='grid grid-cols-2 gap-x-4'>
    <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);

const MarkAsResolvedModal: FC<Props> = ({ show, onClose, onSuccess, review, itemType }) => {
  const [loading, setLoading] = useState(false);
  const markAsResolved = async () => {
    setLoading(true);
    try {
      const url =
        itemType === 'FOOD' ? `brand/reviews/done/${review.id}` : `shop/reviews/done/${review.id}`;
      const res = await apiService.patch(url, { baseUrl });
      toast(<ToastMessage type='success' message={res.data.message} />);
      onSuccess();
      onClose();
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };

  return (
    <BaseModal
      isOpen={show}
      title='Mark as resolved'
      description={`Are you sure you want to mark ${review.user?.first_name}'s review as resolved`}
      titleIcon={<UserIcon />}
      titleIconColor='info'
      onRequestClose={onClose}
      footer={
        <MarkAsResolvedFooter loading={loading} onCancel={onClose} onConfirm={markAsResolved} />
      }
    />
  );
};

export default MarkAsResolvedModal;
